<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
             <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                outlined
                 v-model="price"
                @focus="price=''"
                  label="PRICE PER KILO"
                  :rules="textRules"
                required
                ></v-text-field>

                <v-text-field
                outlined
                 v-model="container"
                  @focus="container=''"
                  label="CONTAINER NO."
                   :rules="textRules"
                   @change="validateContainer()"
                required
                ></v-text-field>
                <v-checkbox
                v-model="borrow"
                label="Borrow container?"
                ></v-checkbox>

             </v-form>
             <v-divider/>
        </v-card-text>
        <v-card-actions>
            
                <v-btn color="default" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="validContainer" small color="success" rounded  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
  mixins: [API_MIXINS],
  props: {
    show: {
        type: Boolean,
        default: false
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      borrow: false,
      price: 0,
      container:'',
      validContainer: false,
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "OK"
         else 
            return "SAVE"
      },
      SHOWBTN() {
          return this.validContainer
      }
  },
  watch: {
    show () {
      if(!this.show) {
          this.borrow = false
          this.price = ''
          this.container = ''
      }
    }
  },
  methods: {
      validate () {
        this.price =  this.price.trim()
        if(!this.$IsNum(this.price)) {
       this.VA_ALERT('error', "Price must be number!")
        return 
        }
          if(this.$IsNum(this.price) == 0) {
           this.VA_ALERT('error', "Enter valid price!")
          return 
        }
       
        if (this.$refs.form.validate()) {
          this.emitToParent(this.state)
        }
      },
    emitToParent (action) {
        var bar = 'yes'
        this.borrow?bar = 'yes':bar = 'no'
        action != 'close'? this.price =  this.price.trim(): this.price = 0
      
      this.$emit('DialogEvent', {action: action, details:{price: this.price, container: this.container, borrowed: bar}})
    },
    validateContainer: function() {
      this.validContainer = false
        this.$http.post("container/validate_container", JSON.stringify({container_no: this.container})).then(response => {
         
            if(response.data.data != null) {
                if(response.data.data[0].status !="used") {
                  this.validContainer = true
                } else {
                    this.validContainer = false
                    this.VA_ALERT('error', "Container is already used!")
                }
             } else {
                 this.validContainer = true
             }
          }).catch(e => {
           console.log(e.data)
         })
      },
  }
}
</script>
